import { defineMessages } from 'react-intl';

export default defineMessages({
  submitButton: {
    id: 'PasswordAccountCreation.buttonText',
    description: 'Create Account Button Text',
    defaultMessage: 'Create Account',
  },
  firstNameError: {
    id: 'PasswordAccountCreation.firstNameErr',
    description: 'First Field Error Message',
    defaultMessage: 'Enter first name. Field cannot be blank.',
  },
  lastNameError: {
    id: 'PasswordAccountCreation.lastNameErr',
    description: 'Last Name Field Error Message',
    defaultMessage: 'Enter last name. Field cannot be blank.',
  },
  phoneNumberError: {
    id: 'PasswordAccountCreation.phoneNumErr',
    description: 'Phone Number Field Error Message',
    defaultMessage: 'Phone number must be 10 digits. (000) 000-0000',
  },
  emptyEmailError: {
    id: 'PasswordAccountCreation.emailEmptyErr',
    description: 'Email Field Error Message',
    defaultMessage: 'Enter valid email address. Field cannot be blank.',
  },
  emailFormatError: {
    id: 'PasswordAccountCreation.emailformatErr',
    description: 'Email Format Error Message',
    defaultMessage: 'Enter valid email address.',
  },
  emailExistsErrorMsg: {
    id: 'PasswordAccountCreation.emailExistsErr',
    description: 'Email Exists Error Message',
    defaultMessage:
      'An account with this email address already exists. Please ',
  },
  emailExistsLoginText: {
    id: 'PasswordAccountCreation.emailExistsLoginText',
    description: 'Email Exists Login Link Text',
    defaultMessage: 'log in',
  },
  emailExistsOrText: {
    id: 'PasswordAccountCreation.emailExistsOrText',
    description: 'Email Exists Or Text',
    defaultMessage: ' or ',
  },
  emailExistsResetText: {
    id: 'PasswordAccountCreation.emailExistsResetText',
    description: 'Email Exists Reset Password Link Text',
    defaultMessage: 'reset your password.',
  },
  emailSubscriptionLabel: {
    id: 'PasswordAccountCreation.emailSubscriptionLabel',
    description: 'Email Subscribe Checkbox Label',
    defaultMessage: 'Sign up for exclusive email promotions',
  },
  emailSubscribeLegalText: {
    id: 'PasswordAccountCreation.emailSubscriptionLegalText',
    description: 'Email Subscribe Legal Label',
    defaultMessage: 'By signing up, you agree to our ',
  },
  emailSubscribeTermsPrivacyText: {
    id: 'PasswordAccountCreation.emailTermsPrivacyText',
    description: 'Email Subscribe Legal Label',
    defaultMessage: 'Terms + Privacy Policy',
  },
  passwordError: {
    id: 'PasswordAccountCreation.passwordErr',
    description: 'Password Field Error Message',
    defaultMessage: 'Enter a password. Field cannot be blank.',
  },
  passwordLengthError: {
    id: 'PasswordAccountCreation.passwordLengthError',
    description: 'PasswordValidation length validation text',
    defaultMessage: '10 characters minimum',
  },
  firstNameLabel: {
    id: 'PasswordAccountCreation.firstNameLabel',
    description: 'First Name Label',
    defaultMessage: 'First Name',
  },
  lastNameLabel: {
    id: 'PasswordAccountCreation.lastNameLabel',
    description: 'Last Name Label',
    defaultMessage: 'Last Name',
  },
  emailLabel: {
    id: 'PasswordAccountCreation.emailLabel',
    description: 'Email Label',
    defaultMessage: 'Email',
  },
  phoneLabel: {
    id: 'PasswordAccountCreation.phoneLabel',
    description: 'Phone Number Label',
    defaultMessage: 'Phone Number',
  },
  passwordLabel: {
    id: 'PasswordAccountCreation.passwordLabel',
    description: 'Password Label',
    defaultMessage: 'Create Password',
  },
  emailNotVerifiedErrorTitle: {
    id: 'PasswordAccountCreation.emailNotVerifiedErrorTitle',
    description: 'verification needed title',
    defaultMessage: 'VERIFICATION NEEDED',
  },
  emailNotVerifiedErrorPt1: {
    id: 'PasswordAccountCreation.emailNotVerifiedErrorPt1',
    defaultMessage: 'We’ve sent a verification email to',
  },
  emailNotVerifiedErrorPt2: {
    id: 'PasswordAccountCreation.emailNotVerifiedErrorPt2',
    defaultMessage: 'Once you’ve verified your email you’ll be able to sign in.',
  },
  resendVerificationEmailPt1: {
    id: 'PasswordAccountCreation.resendVerificationEmailPt1',
    defaultMessage: 'If you didn’t recieve an email, ',
  },
  resendVerificationEmailPt2: {
    id: 'PasswordAccountCreation.resendVerificationEmailPt2',
    defaultMessage: 'click here',
  },
  resendVerificationEmailPt3: {
    id: 'PasswordAccountCreation.resendVerificationEmailPt3',
    defaultMessage: 'to resend the verification email.',
  },
  resendVerifyMessagePt1: {
    id: 'LoginModal.resendVerifyMessagePt1',
    description: 'Login modal verification email resent message part 1',
    defaultMessage: 'Verification email resent to',
  },
  resendVerifyMessagePt2: {
    id: 'LoginModal.resendVerifyMessagePt2',
    description: 'Login modal verification email resent message part 1',
    defaultMessage: 'It may take a few minutes.',
  },
  backBtn: {
    id: 'PasswordAccountCreation.back',
    description: 'Login modal back button',
    defaultMessage: 'Back',
  },
});
